import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import Calculator from "../../components/Calculator/calculator";
import Faq from "../../components/faq/faq";
import Footer from "../../components/footer/footer";
import GlobalCommunity from "../../components/globalCommunity/globalCommunity";
import Header from "../../components/header/header";
import HowItWorksVidoes from "../../components/howitWorksVideos/howItWorksVidoes";
import LatestTransactions from "../../components/latestTransactions/latestTransactions";
import OurInvestors from "../../components/ourInvestors/OurInvestors";
import OurPlan from "../../components/OurPlan/ourPlan";
import OurServices from "../../components/ourServices/ourServices";
import PaymentAccepted from "../../components/paymentAccepted/paymentAccepted";
import Preloader from "../../components/preloader/Preloader";
import Slider from "../../components/slider/slider";
import Testionials from "../../components/testimonials/Testionials";
import WhoWeAre from "../../components/whoWeAre/whoWeAre";
import { firestore } from "../../db/config";

export default function Home() {
  const dispatch = useDispatch();
  useEffect(() => {
    const getRef = firestore.collection("investmentPlan").get();
    getRef.then((plans) => {
      const getPlans = plans.docs.map((data) => data.data());

      dispatch({ type: "investment_details", data: getPlans });
    });
  });
  return (
    <div>
      <Header />
      <Slider />
      <WhoWeAre />
      <OurPlan />
      {/* <Calculator /> */}
      <GlobalCommunity />
      <OurServices />
      <HowItWorksVidoes />
      <LatestTransactions />

      <Testionials />
      {/* <OurInvestors /> */}
      {/* <Faq /> */}
      <PaymentAccepted />
      <Footer />
    </div>
  );
}
